import { Component, OnInit ,HostListener, ViewChild, TemplateRef} from '@angular/core';
import { Router } from '@angular/router';
declare var $: any;
declare let jQuery: any;
@Component({
  selector: 'app-final',
  templateUrl: './final.component.html',
  styleUrls: ['./final.component.scss']
})

export class FinalComponent implements OnInit {
  modalRef: any;
  @ViewChild("content") modalContent: TemplateRef<any>;
  constructor(private router: Router) { }

  ngOnInit() {
   // this.modalRef.close(this.modalContent)
   jQuery(document).ready(function ($) {
    if(navigator.userAgent.indexOf("Firefox") != -1 )
    {
      if (window.history && window.history.pushState) {

        $(window).on('popstate', function () {
          var hashLocation = location.hash;
          var hashSplit = hashLocation.split("#!/");
          var hashName = hashSplit[1];

          if (hashName !== '') {
            var hash = window.location.hash;
          }
        });
        window.history.pushState('/', null, './');
      }
  }
  });
  }
  @HostListener('window:popstate', ['$event'])
  onBrowserBackBtnClose(event: Event) {


    event.preventDefault();
   // window.history.forward();
    //history.pushState(null, null, '/');
    this.router.navigate(['/'],  {replaceUrl:true});
}
@HostListener('contextmenu', ['$event'])
onRightClick(event) {
  event.preventDefault();
}
}
